/**
 * Truncates a given name to a specified maximum length and appends "..." if the name exceeds the limit.
 * Displays the full name as a tooltip when truncated.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.name - The name to be truncated.
 * @param {number} [props.maxLength=15] - The maximum length of the truncated name. Defaults to 15 if not provided.
 * @return {JSX.Element} A span element containing the truncated name or the full name if it does not exceed the maximum length.
 */
function TruncatedName({ name, maxLength = 24 }) {
  if (name.length <= maxLength) {
    return <span>{name}</span>;
  }

  const truncatedName = name.substring(0, maxLength) + "...";

  return <span title={name}>{truncatedName}</span>;
}

export default TruncatedName;
